export var P44EnvEnum;
(function (P44EnvEnum) {
    P44EnvEnum["LOCAL"] = "local";
    P44EnvEnum["QA_INTEGRATION"] = "qa-integration";
    P44EnvEnum["QA_STAGE"] = "qa-stage";
})(P44EnvEnum || (P44EnvEnum = {}));
